import { render, staticRenderFns } from "./network.vue?vue&type=template&id=0dedff18&scoped=true&"
import script from "./network.vue?vue&type=script&lang=js&"
export * from "./network.vue?vue&type=script&lang=js&"
import style0 from "./network.vue?vue&type=style&index=0&id=0dedff18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dedff18",
  null
  
)

export default component.exports